import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import * as S from './styles';
import { match } from '~/utils/mocks/match';
import {
  ArbitrationTeam,
  GrassStatus,
  KitSelector,
  MatchSheet,
  ProtocolCommercialActs,
} from '~/pages/Match/subpages/Previous/subpages';

export default function NavigationBar() {
  const { path } = useRouteMatch();
  const newPath = `${path}/previous`;

  return (
    <S.Content>
      <Switch>
        <Route
          path={`${newPath}/arbitration-team`}
          component={ArbitrationTeam}
        />
        <Route
          path={`${newPath}/kit-selector`}
          component={() => <KitSelector match={match} />}
        />
        <Route path={`${newPath}/grass-status`} component={GrassStatus} />
        <Route path={`${newPath}/match-sheet`} component={MatchSheet} />
        <Route
          path={`${newPath}/protocol-commercial-acts`}
          component={ProtocolCommercialActs}
        />
      </Switch>
    </S.Content>
  );
}
